import { render, staticRenderFns } from "./DialogThankYou.vue?vue&type=template&id=8fe1b4ea&scoped=true"
import script from "./DialogThankYou.vue?vue&type=script&lang=js"
export * from "./DialogThankYou.vue?vue&type=script&lang=js"
import style0 from "./DialogThankYou.vue?vue&type=style&index=0&id=8fe1b4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe1b4ea",
  null
  
)

export default component.exports